import React, { useEffect } from "react";
import utils from "./utils";
import classes from "./index.module.css";
import RadioButton from "../../base-components/radio-button";
import Button from "../../base-components/button";
import List from "../../base-components/list";
import { dashboard } from "../../redux/thunk/app.thunk";
import { useDispatch, useSelector } from "react-redux";
import { dateFormat } from "../../utilities/Helpers";
import { DashboardAction } from "../../utilities/Variables";

const ShowHoldings = () => {
  const [activeButton, setActiveButton] = React.useState("");
  const [isSellWithdrawLoading, setIsSellWithdrawLoading] =
    React.useState(false);
  const isLoading = useSelector((state) => state.app.isLoading);
  const dispatch = useDispatch();
  const accountDetail = useSelector((state) => state.app.accountDetail);
  const stocks = accountDetail?.stocks || [];
  const totalValue = parseFloat(accountDetail?.total_value) || 0.0;
  const withdrawalDesc = accountDetail?.withdrawal_desc || "";
  const transactionHistory = accountDetail?.transaction_history || [];

  useEffect(() => {
    dispatch(
      dashboard({
        action: DashboardAction.CheckStatus,
      })
    );
  }, []);

  const onSellWithdraw = () => {
    setIsSellWithdrawLoading(true);
    dispatch(
      dashboard({
        action: DashboardAction.Sell,
      })
    ).then((response) => {});
  };

  const onSubmit = () => {
    setIsSellWithdrawLoading(false);
    dispatch(
      dashboard({
        action: DashboardAction.CheckStatus,
      })
    );
  };

  const stockFilter = stocks.filter(item => item.status.toLowerCase() === utils.Status.Active)

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>{utils.SHOW_HOLDINGS_HEADER}</h2>
        <div className={classes.topMiddle}>
          <h3 className={classes.SubHeading}>
            {utils.SHOW_HOLDINGS_SUBHEADING.label}: $
            {totalValue?.toFixed(2)?.toLocaleString()}
          </h3>
        </div>
      </div>
      <div className={classes.middle}>
        <div className={classes.stockView}>
          {stocks.map((item) => {
            const classNameStyle = item.status.toLowerCase() === utils.Status.Active ? classes.stockBoldActive : classes.stockBoldSold
            return (
              <div className={classes.stock}>
                <p className={classes.stockBold}>
                  {item.symbol}
                  {": $"}
                  {parseFloat(item.amount)?.toFixed(2)?.toLocaleString()}
                </p>
                <p className={classes.stockBold}>
                  {item.percentage + "% of portfolio"}
                </p>
                <p className={classes.stockBold}>
                  {`Number of shares: ${item.shares}`}
                </p>
                <p className={classes.stockBold}>
                  {`Value in Portfolio: $${parseFloat(item.value)
                    ?.toFixed(2)
                    ?.toLocaleString()}`}
                </p>
                <p className={classes.stockDescription}>{item.description}</p>
                <p className={classNameStyle}>{`Status: ${item.status}`}</p>
              </div>
            );
          })}
          {stocks.length === 0 && (
            <div className={classes.transactionHistory}>
              <p className={classes.noHistory}>{`No assets in account.`}</p>
            </div>
          )}
          {withdrawalDesc.length > 0 && <p className={classes.withdrawalDesc}>{withdrawalDesc}</p>}
        </div>
        <Button
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            marginBottom: "20px",
            alignItems: "center",
          }}
          loading={isSellWithdrawLoading && isLoading}
          state={stockFilter.length === 0 ? "disabled" : "active"}
          action={onSellWithdraw}
        >
          {utils.SHOW_HOLDINGS_BUTTON_HEADING_2}
        </Button>
        <Button
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={!isSellWithdrawLoading && isLoading}
          state={undefined}
          action={onSubmit}
        >
          {utils.SHOW_HOLDINGS_BUTTON_HEADING}
        </Button>
      </div>
      <div className={classes.bottom}>
        <h2 className={classes.Heading}>{utils.SHOW_HOLDINGS_HEADER_2}</h2>
        {transactionHistory.map((item) => {
          return (
            <div className={classes.stock}>
              <p style={{ marginBottom: "3px" }}>{item.description}</p>
              <p style={{ marginTop: "3px" }}>{dateFormat(item.date)}</p>
            </div>
          );
        })}
        {transactionHistory.length === 0 && (
          <div className={classes.transactionHistory}>
            <p className={classes.noHistory}>
              {`No trasaction history found.`}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShowHoldings;
